import { getCapturedPageProperties, getCapturedReferrer, } from 'utils/url-capture';
/**
 * Returns captured page context to override Segment's automatic page context.
 * This prevents loss of UTM parameters and referrer when URL is modified by
 * client-side routing before Segment captures the page context.
 */
export const withCapturedPage = () => {
    const { url, path, search } = getCapturedPageProperties();
    const referrer = getCapturedReferrer();
    return {
        page: {
            url,
            path,
            search,
            referrer,
            // Keep document.title as-is since it's not affected by routing
            title: typeof document !== 'undefined' && document.title
                ? document.title
                : '',
        },
    };
};
